module.exports = __webpack_public_path__ + "img/icon20.6903b57.png";